import UsersList from './UsersList'
import UsersSingle from './UsersSingle'
import UserAccount from './UserAccount'

export default {
  UsersList,
  UsersSingle,
  UserAccount
}
